import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import useJobFilters from '@hooks/useJobFilters'
import useCoursesFilter from '@hooks/useCoursesFilter'
import useCourseAuthorFilter from '@hooks/useCourseAuthorFilter'
import { CURRENT_STATUS_FILTER } from '@const/filters'
import { FilterTypes } from '@templates/ListPageLayout/Filters/Filter'
import { FiltersProps } from '@templates/ListPageLayout/Filters'
import { FilterState } from '@hooks/useItemsFilters'
import ASSIGN_TYPES from '@const/assignTypes'

const useEmployeesEducationFilters = (methods: UseFormReturn): FiltersProps => {
  const { company, filial, division, position } = useJobFilters(methods)

  const courseAuthorValue = methods.watch('courseAuthor')
  const courseAuthorOption = Array.isArray(courseAuthorValue)
    ? courseAuthorValue[0]
    : courseAuthorValue

  const coursesForcedFilters = useMemo<FilterState | undefined>(() => {
    if (!courseAuthorOption?.value) return undefined
    return { courseAuthorId: courseAuthorOption.value }
  }, [courseAuthorOption?.value])

  const courseAuthor = useCourseAuthorFilter('courseAuthorId')
  const courses = useCoursesFilter('course', coursesForcedFilters)

  const filters: FiltersProps = [
    {
      filterType: FilterTypes.EMPLOYEE,
      fieldName: 'employees',
      fieldNameForSubmit: 'employeeEducationDestinations.employee',
    },
  ]

  if (company) {
    filters.push(company)
  }

  if (filial) {
    filters.push(filial)
  }

  if (division) {
    filters.push(division)
  }

  if (position) {
    filters.push(position)
  }

  filters.push(
    {
      filterType: FilterTypes.DATE,
      fieldName: 'createdAt[after]',
      placeholder: 'Дата назначения от',
      transformValue: (filter) => ({
        'createdAt[after]': filter['createdAt[after]'] + 'T00:00:00',
      }),
    },
    {
      filterType: FilterTypes.DATE,
      fieldName: 'createdAt[before]',
      placeholder: 'Дата назначения до',
      transformValue: (filter) => ({
        'createdAt[before]': filter['createdAt[before]'] + 'T23:59:59',
      }),
    },
    {
      filterType: FilterTypes.SELECT,
      fieldName: 'type',
      placeholder: 'Тип назначения',
      options: ASSIGN_TYPES,
      withoutFetchOptions: true,
      isMulti: true,
    },
    courseAuthor,
    courses,
    CURRENT_STATUS_FILTER,
    {
      filterType: FilterTypes.HIDDEN,
      fieldName: 'id',
    }
  )

  return filters
}

export default useEmployeesEducationFilters
